var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationLaptopDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 974,
    height: 786,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "27.97%",
    x2: "100%",
    y2: "72.03%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-16.5%",
    y: "-28.5%",
    width: "132.9%",
    height: "157.1%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.421821759 0 0 0 0 0.554338424 0 0 0 0 0.893710371 0 0 0 0.243444056 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 506,
    height: 335.872,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0h692.9a3 3 0 013 3v14.105H0V3a3 3 0 013-3z",
    id: "e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.5,
    transform: "matrix(1 0 0 -1 0 786)",
    x: 59.5,
    y: 59.5,
    width: 665,
    height: 667,
    rx: 332.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.25,
    transform: "matrix(1 0 0 -1 0 786)",
    x: 0.5,
    y: 0.5,
    width: 783,
    height: 785,
    rx: 391.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2D2E40",
    opacity: 0.08,
    transform: "matrix(1 0 0 -1 0 786)",
    x: 117,
    y: 117,
    width: 550,
    height: 552,
    rx: 275
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 192)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#535353",
    fillRule: "nonzero",
    x: 82,
    y: 16,
    width: 538,
    height: 368,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1D1D25",
    fillRule: "nonzero",
    x: 85,
    y: 19,
    width: 532,
    height: 362,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99 32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F6F6",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: -0.325,
    y: 60.293,
    width: 506,
    height: 275.838,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.475 37.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 106.646,
    height: 256.541,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 124.798,
    width: 238.251,
    height: 256.541,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 135.009,
    y: 13.622,
    width: 217.83,
    height: 60.162,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 135.009,
    y: 86.27,
    width: 64.668,
    height: 60.162,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 215.561,
    y: 86.27,
    width: 137.278,
    height: 60.162,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349)",
    fill: "#4A5166",
    fillRule: "nonzero",
    opacity: 0.098
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    width: 3.2,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 380)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#52526F",
    fillRule: "nonzero",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2F2F47",
    fillRule: "nonzero",
    mask: "url(#f)",
    x: 292.371,
    y: -41.908,
    width: 114.156,
    height: 52.171,
    rx: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 397h699a6 6 0 01-6 6H6a6 6 0 01-6-6z",
    fill: "#393A56",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLaptopDesktop);
export default __webpack_public_path__ + "static/media/illustration-laptop-desktop.799209c2628b1f244e1512cc686f0162.svg";
export { ForwardRef as ReactComponent };